import { styled } from '../../Utilities';
import { ButtonGridBase } from './ButtonGrid.base';
import { getStyles } from './ButtonGrid.styles';
export var ButtonGrid = styled(ButtonGridBase, getStyles);
/**
 * @deprecated - use ButtonGrid instead
 */
export var Grid = ButtonGrid;
//# sourceMappingURL=ButtonGrid.js.map